import axios from 'axios';

const defaultURL = 'https://treant.ru';
const storageKey = 'api_server_url';

const GetAPIServerURL = () => { 
  var url = localStorage.getItem(storageKey);
  if (!url) {
    url = defaultURL
    localStorage.setItem(storageKey, url);
  }
  return url;
}

const api = axios.create({
  baseURL: GetAPIServerURL() + '/api', // Через Nginx
});

// Interceptor для добавления токена в заголовки
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor для отлова 401 ошибки
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem('access_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

api.getLayoutingSheetPreview = (imageId) => {
  return GetAPIServerURL() + `/api/layouting/sheets/preview/${imageId}.jpg`
}

export default api;